export function hasAttr(el, attr) {
  return el.hasAttribute(attr);
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/hasAttr.js
// module id = 848
// module chunks = 2